import { useState, useEffect, useContext } from 'react';
import AuthContext from '../contexts/auth';
import { usePlatforms } from '../hooks/usePlatforms';
import { translate } from '../utils/Common';
import ignoreAbort from '../utils/ignoreAbort';


const PlatformList = ({
    register, 
    errors,
    nameShow,
    idShow,
    readOnly,
    idPlatform,
    handleIsBoxit,
    sizeInput,
    isRequired = true
}) => {
    const userContext = useContext(AuthContext);
    const { platforms, getPlatforms } = usePlatforms();
    const [plataformasList,setPlataformasList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [noPlatformsMessage, setNoPlatformsMessage] = useState(null);


    useEffect(() => {
        const abortController = new AbortController();

        const handlePlatforms = async () => {
            setLoading(true);
            const platforms = await getPlatforms(userContext.user?.IdCliente, abortController.signal);
            if (platforms && platforms.length > 0) {
                setPlataformasList(platforms);
            } else {
                setNoPlatformsMessage(translate("global.noPlatforms"));
            }
            setLoading(false);
        }

        if (!platforms) handlePlatforms().catch(ignoreAbort)
        else setPlataformasList(platforms)
        
        return () => abortController.abort();
    }, [platforms, getPlatforms, userContext.user?.IdCliente]);

    useEffect(() => {
        if (idPlatform !== translate("global.select") && idPlatform !== translate("global.noPlatforms")) {
            const isBoxitSelected = platforms?.filter(p => p.boxitLocationId === Number(idPlatform)) && platforms?.filter(p => p.boxitLocationId === Number(idPlatform))[0]?.IsBoxit;
            if (handleIsBoxit) handleIsBoxit(isBoxitSelected);
        }
    }, [idPlatform, handleIsBoxit, platforms])
    return  (
        <>
             <select
            className={`${sizeInput ?? "h-9 text-sm"} h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-small`}
            readOnly={readOnly}
            name="plataforma"
            ref={register({
                validate: isRequired ? 
                    (value => value !== (translate("global.select") || translate("components.showItems.results.NOT_PLATFORMS")) || translate("global.chooseValidBoxit")) :
                    undefined
            })}
        >
            <option defaultValue key={0} className="text-sm">
                {nameShow ? nameShow : translate("global.noPlatform")}
            </option>
{plataformasList ? (
            plataformasList?.map(
              (prov) =>
                idShow !== prov.boxitLocationId && (
                  <option
                    key={prov.boxitLocationId}
                    className="text-sm"
                    value={prov.boxitLocationId}
                  >{`${prov.locationName}`}</option>
                )
            )
          ) : (
            <option className="text-sm">
              {noPlatformsMessage ? noPlatformsMessage : translate("global.noPlatforms")}
            </option>
          )}
        </select>
        {errors.plataforma && <span className="text-destructive">{errors.plataforma.message}</span>}
        </>
    )
}

export default PlatformList;